import useLocale from '@hooks/useLocale'
import { useTheme } from '@mui/material/styles'
import { useMemo } from 'react'

import { dateCellRenderer } from './DateCell'
import { dropdownCellRenderer } from './DropdownCell'
import { moneyCellRenderer } from './MoneyCell'
import { multiPillCellRenderer } from './MultiPillCell'
import { numberCellRenderer } from './NumberCell'
import { pillCellRenderer } from './PillCell'
import { statusCellRenderer } from './StatusCell'
import { thumbnailCellRenderer } from './ThumbnailCell'

export function useCustomCellRenderers() {
  const { locale } = useLocale()
  const theme = useTheme()
  const renderers = useMemo(
    () => [
      pillCellRenderer(),
      statusCellRenderer(theme),
      numberCellRenderer(locale),
      dateCellRenderer(locale),
      moneyCellRenderer(locale),
      multiPillCellRenderer(theme),
      dropdownCellRenderer,
      thumbnailCellRenderer,
    ],
    [locale, theme],
  )

  return renderers
}
